import { useCreateCtx } from '@cleartax/wg-library-hooks';
export interface IStarRatingContext {
  emptyColor: string;
  fillColor: string;
  height: number;
  hover: number | null;
  labelText: (value: number) => React.ReactNode;
  rating: number;

  setHover: (value: number | null) => void;
  setRating: (value: number) => void;
  width: number;
  maxValue: number;
}
export const [useStarRatingCtx, StarRatingProvider] =
  useCreateCtx<IStarRatingContext>();
